import script from "./BookNow.vue?vue&type=script&setup=true&lang=js"
export * from "./BookNow.vue?vue&type=script&setup=true&lang=js"

import "./BookNow.vue?vue&type=style&index=0&id=37766c0e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src437516949/src/dublinfarmstownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37766c0e"]])

export default __exports__